export default function formatValorMonetario(valor?: number) {
  if (valor === undefined) return valor;
  return Number(valor).toLocaleString("pt-br", {
    style: "currency",
    maximumFractionDigits: 2,
    currency: "BRL",
    minimumFractionDigits: 2,
  });
}
